<div mat-dialog-title *ngIf="this.data.isModifica">Modifica Capitolo</div>
<div mat-dialog-title *ngIf="!this.data.isModifica">Aggiungi Capitolo</div>
<div style="height: 20px"></div>
<form
  [formGroup]="form"
  appFormContainer
  [larghezza]="3"
  [gap]="10"
  [rowGap]="5"
  style="align-items: center"
>
  <mat-form-field appFormElement [larghezza]="3">
    <mat-label>Titolo Capitolo</mat-label>
    <input matInput placeholde="Titolo Capitolo" formControlName="descrizioneIndice" />
    <mat-error appFormError></mat-error>
  </mat-form-field>
</form>

<div style="display: flex; flex-direction: row; column-gap: 20px">
  <button mat-flat-button mat-dialog-close color="accent" class="accent-button">Chiudi</button>

  <button mat-flat-button color="primary" (click)="conferma()" class="primary-button">
    Conferma
  </button>
</div>
